export function isMobile(widthIpads?: boolean) {
    return (window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth) <= (widthIpads ? 1090 : 680);
}